const CommendaLogo = ({ collapsed = false }: { collapsed?: boolean }) => {
  if (collapsed) {
    return (
      <img src="/commenda-new-logo.svg" alt="Commenda" className="h-5 w-5" />
    );
  }

  return (
    <img
      src="/commenda-text-logo.svg"
      alt="Commenda"
      className="h-[18px] w-[123px]"
    />
  );
};

export { CommendaLogo };
